export default "__VITE_ASSET__DMMR9zq$__"